import styled from '@emotion/styled';
import { TimerVariant } from '@/common/countdownTimer/CountdownTimer';

export const TimerBannerSection = styled.div<{ $variant?: TimerVariant }>`
    flex: 1 0 50%;
    width: 50%;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    color: #E21216;
    font-size: 14px;
    border-top: 1px solid #CFCECC;
    border-right: 1px solid #CFCECC;
    border-bottom: 1px solid #CFCECC;
    height: 27px;
    border-radius: 0 4px 4px 0;

    @media (max-width: 710px) {
        font-size: 12px;
    }

    ${props => props.$variant === 'deals' && `
      @media (max-width: 950px) {
        width: 100%;
        flex: none;
        padding: 6px 12px;
        height: 24px;
        border-radius: 0;
        border: none;
      }
  `}
    
    ${props => props.$variant === 'sidekicks' && `
      border-radius: 0;
      @media (max-width: 900px) and (min-width: 651px) {
        width: 100%;
        flex: none;
        padding: 6px 12px;
        height: 24px;
        border-radius: 0 0 0 0;
      }
  `}
`;
